import * as breakTriggers from './triggers/break';
import * as liveTriggers from './triggers/live';
import * as breakSequences from './sequences/break';
import * as liveSequences from './sequences/live';
import moment from 'moment';
const BreakTriggers = Object.keys(breakTriggers).reduce((all, curr) => {
    all[curr] = curr;
    return all;
}, {});
const LiveTriggers = Object.keys(liveTriggers).reduce((all, curr) => {
    all[curr] = curr;
    return all;
}, {});
export const breakTriggerSequences = {
    [BreakTriggers.PREGAME_PRE_PLAYERS]: breakSequences.pregame
};
export const breakFactTriggerSequencMap = {
    [BreakTriggers.ABOUT_TO_START]: breakSequences.periodAboutToStart,
    [BreakTriggers.PLAYERS_ENTERING_NOT_PREGAME]: breakSequences.playersEnteringNotPregame,
    [BreakTriggers.PLAYERS_ENTERING_PREGAME]: breakSequences.playersEnteringPregame
};
export const liveFactTriggerSequenceMap = {
    [LiveTriggers.TRY]: liveSequences.footballTry,
    [LiveTriggers.PENALTY_GOAL]: liveSequences.penaltyGoal,
    [LiveTriggers.DROP_GOAL]: liveSequences.dropGoal,
    [LiveTriggers.CONVERSION_MADE]: liveSequences.conversion
};
// Returns the intiial overlay timeline that initialized the state.
export const createBreakTimeline = (currentPeriod) => {
    const periodStarted = currentPeriod.started ? moment.utc(currentPeriod.started).toDate() : undefined;
    const now = new Date();
    const startOffset = now.getTime() - (periodStarted || now).getTime();
    // console.log(currentPeriod, startOffset);
    if (currentPeriod.aboutToStart) {
        return breakSequences.periodAboutToStart;
    }
    if (currentPeriod.pregame) {
        if (currentPeriod.playersEntered) {
            return breakSequences.playersEnteringPregame;
        }
        return breakSequences.pregame;
    }
    if (currentPeriod.playersEntered) {
        return breakSequences.playersEnteringNotPregame;
    }
    // Will exist when period isn't pregame or postgame.
    if (currentPeriod.duration > 5 || currentPeriod.matchFinished) {
        return breakSequences.longBreak;
    }
    return breakSequences.shortBreak;
};
export const createLiveTimeline = (currentPeriod) => {
    if (currentPeriod.shootout) {
        return liveSequences.hideAll;
    }
    // check if shootout, if so hide
    if (currentPeriod.shootout) {
        return liveSequences.hideAll;
    }
    return liveSequences.showScoreboard;
};
//# sourceMappingURL=index.js.map